interface ToggleProps {
  on: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  id?: string;
}

export function Toggle({ on, onChange, disabled, id }: ToggleProps) {
  return (
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={on}
      disabled={disabled}
      className={`toggle${on ? ' toggle--on' : ''}`}
      onClick={() => onChange(!on)}
    />
  );
}
